import { createFileRoute } from '@tanstack/react-router';
import { CompanyChainsList } from '@/app/(client)/supply-chain-mapping/-components/CompanyChainsList';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/active/',
)({
  component: ActiveSupplyChainsPage,
});

function ActiveSupplyChainsPage() {
  return <CompanyChainsList isArchived={false} />;
}
